import React from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import { Row, Col, Card } from "react-bootstrap";
import MenuItemCard from "../../organisms/MenuItemCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TodayIcon from "@mui/icons-material/Today";
import PersonIcon from "@mui/icons-material/Person";
import PetsIcon from "@mui/icons-material/Pets";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useUsuarioActual } from "../../../services/authServicios";
import {
  puedeAccederRuta,
} from "../../../services/rolAutorizacion";
import {
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO,
  RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES,
} from "../../../services/rutas";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/analisis", label: "Análisis" },
  { path: "/analisis/finanzas", label: "Finanzas", isActive: true },
];

function Finanzas() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Page
      title="Análisis Financieros"
      description="Informes y métricas financieras."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
          <Card>
            <Card.Body>
              <Row className="justify-content-center mb-2 p-2">
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={CalendarMonthIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES}
                      titulo="Ingresos por mes"
                      descripcion="Ingresos agrupados por mes."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={TodayIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA}
                      titulo="Ingresos por día"
                      descripcion="Ingresos desglosados por día."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={PersonIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO}
                      titulo="Ingresos por propietario"
                      descripcion="Ingresos asociados a cada propietario."
                    />
                  </CardCol>
                )}
            </Row>
              <Row className="justify-content-center mb-2 p-2">
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={PetsIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA}
                      titulo="Ingresos por mascota"
                      descripcion="Ingresos por mascota."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={MiscellaneousServicesIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO}
                      titulo="Ingresos por servicio"
                      descripcion="Ingresos discriminados por servicio de todos los tipos."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={AccountBalanceWalletIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO}
                      titulo="Deudas por propietario"
                      descripcion="Propietarios con saldos pendientes."
                    />
                  </CardCol>
                )}
                </Row>
                <Row className="justify-content-center mb-2 p-2">
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={LocalOfferIcon}
                      ruta={RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES}
                      titulo="Descuentos por mes"
                      descripcion="Descuentos aplicados por mes."
                    />
                  </CardCol>
                )}
              </Row>
            </Card.Body>
          </Card>
        </div>
      </Row>
    </Page>
  );
}

const CardCol = ({ children }: { children: React.ReactNode }) => (
  <Col xs={12} md={4} sm={6}>
    {children}
  </Col>
);

export default Finanzas;
